/* eslint-disable eqeqeq */
/**
 * https://stackoverflow.com/a/63090810/828023
    Init locale formatter:
    
        timespan.locale(@locale, @style)
    
    Example:

        timespan.locale('en-US', 'long');
        timespan.locale('es', 'narrow');

    Format time delta:
    
        timespan.format(@pattern, @milliseconds)

        @pattern tokens:
            D: days, h: hours, m: minutes, s: seconds, f: millis

        @pattern token extension:
            h  => '0'-padded value, 
            h# => raw value,
            h~ => locale formatted value

    Example:

        timespan.format('D~ h~ m~ s~ f "millis"', 1234567890);
        
        output: 14 days 6 hours 56 minutes 7 seconds 890 millis

    NOTES:

    * milliseconds unit have no locale translation
    * may encounter declension issues for some locales
    * use quoted text for raw inserts
            
*/

export const timespan = (() => {
  let rtf, tokensRtf;
  const tokens = /[Dhmsf][#~]?|"[^"]*"|'[^']*'/g,
    map = [
      { t: [["D", 1], ["D#"], ["D~", "day"]], u: 86400000 },
      { t: [["h", 2], ["h#"], ["h~", "hour"]], u: 3600000 },
      { t: [["m", 2], ["m#"], ["m~", "minute"]], u: 60000 },
      { t: [["s", 2], ["s#"], ["s~", "second"]], u: 1000 },
      { t: [["f", 3], ["f#"], ["f~"]], u: 1 },
    ],
    locale = (value = "en-US", style = "long") => {
      try {
        rtf = new Intl.RelativeTimeFormat(value, { style });
      } catch (e) {
        if (rtf) throw e;
        return;
      }
      const h = rtf.format(1, "hour").split(" ");
      tokensRtf = new Set(
        rtf
          .format(1, "day")
          .split(" ")
          .filter((t) => t != 1 && h.indexOf(t) > -1)
      );
      return true;
    },
    fallback = (t, u) => u + " " + t.fmt + (u == 1 ? "" : "s"),
    mapper = {
      number: (t, u) => (u + "").padStart(t.fmt, "0"),
      string: (t, u) =>
        rtf
          ? rtf
              .format(u, t.fmt)
              .split(" ")
              .filter((t) => !tokensRtf.has(t))
              .join(" ")
              .trim()
              .replace(/[+-]/g, "")
          : fallback(t, u),
    },
    replace = (out, t) => out[t] || t.slice(1, t.length - 1),
    format = (pattern, value) => {
      if (typeof pattern !== "string") throw Error("invalid pattern");
      if (!Number.isFinite(value)) throw Error("invalid value");
      if (!pattern) return "";
      const out = {};
      value = Math.abs(value);
      const patternMatch = pattern.match(tokens);
      if (patternMatch) {
        patternMatch.forEach((t) => (out[t] = null));
      }

      map.forEach((m) => {
        let u = null;
        m.t.forEach((t) => {
          if (out[t.token] !== null) return;
          if (u === null) {
            u = Math.floor(value / m.u);
            value %= m.u;
          }
          out[t.token] = "" + (t.fn ? t.fn(t, u) : u);
        });
      });
      return pattern.replace(tokens, replace.bind(null, out));
    };
  map.forEach(
    (m) =>
      (m.t = m.t.map((t) => ({
        token: t[0],
        fmt: t[1],
        fn: mapper[typeof t[1]],
      })))
  );
  locale("en");
  return { format, locale };
})();
